import React from 'react';
import { Button } from '../../../components/ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '../../../components/ui/dialog';
import { RotateCcw, CheckCircle } from 'lucide-react';

export const BulkRestoreDialog = ({ 
  open, 
  onOpenChange, 
  selectedCount,
  loading,
  onConfirm 
}) => {
  return (
    <Dialog open={open} onOpenChange={(open) => !loading && onOpenChange(open)}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-green-600">
            <RotateCcw className="w-5 h-5" />
            Bulk Restore Employees
          </DialogTitle>
          <DialogDescription>
            You are about to restore <strong>{selectedCount}</strong> deleted employees. They will be reactivated with their previous status.
          </DialogDescription>
        </DialogHeader>
        <div className="py-4">
          <div className="flex items-center gap-3 p-3 bg-green-50 border border-green-200 rounded-lg">
            <CheckCircle className="w-5 h-5 text-green-600 flex-shrink-0" />
            <div className="text-sm text-green-800">
              <p className="font-medium">Restore Operation</p>
              <p className="text-green-600">Employees will be restored to their previous active status and their user accounts will be reactivated.</p>
            </div>
          </div>
        </div>
        <DialogFooter>
          <Button 
            variant="outline" 
            onClick={() => onOpenChange(false)}
            disabled={loading}
          >
            Cancel
          </Button>
          <Button 
            className="bg-green-600 hover:bg-green-700"
            onClick={onConfirm}
            disabled={loading}
            data-testid="confirm-bulk-restore"
          >
            {loading ? 'Restoring...' : `Restore ${selectedCount} Employees`}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default BulkRestoreDialog;
